import { GHLRequestHeaders } from "../schemas/ghl";
import { parseSchema } from "../utils";
import { type ContactCreate } from "./contact-update.model";
import contactSchema, { type Contact } from "./contact.model";
import * as v from "valibot";

export async function upsertContact(
  body: ContactCreate,
  accessToken: string,
): Promise<{ new: boolean; contact: Contact }> {
  const headers: GHLRequestHeaders = {
    Authorization: `Bearer ${accessToken}`,
    Version: "2021-07-28",
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const response = await fetch(
    `https://services.leadconnectorhq.com/contacts/upsert`,
    {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    },
  );

  const json = await response.json();
  if (!response.ok) {
    console.error("[updateContact] Error response from GHL", json);
    throw new Error(`[updateContact] HTTP error! Status: ${response.status}`, {
      cause: response,
    });
  }

  return parseSchema(
    v.object({
      new: v.boolean(),
      contact: contactSchema,
    }),
    json,
  );
}
